// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\pages\\studios\\BookSection\\index.ts"
);
import.meta.hot.lastModified = "1757171103344.3704";
}
// REMIX HMR END

export { BookSection } from "./BookSection";